export default {
  hero: { eyebrow: 'Competition Studio · Premium Module', title: 'Build elite competitions that feel like broadcast events.', subtitle: 'Design golf, racquet, and hybrid competition experiences with premium sponsor surfaces, real-time storytelling, and launch-ready control workflows.' },
  actions: { create: 'Create Competition', creating: 'Creating…', demo: 'Launch Demo Mode', addScreen: 'Add Screen', createGroup: 'Create Screen Group', newCampaign: 'New Sponsor Campaign', previewBroadcast: 'Preview Broadcast', startBroadcast: 'Start Broadcast', pauseBroadcast: 'Pause Broadcast', pushAnnouncement: 'Push Announcement', finalsMode: 'Enter Finals Mode' },
  metrics: { activeCompetitions: 'Active Competitions', screensSynced: 'Screens Synced', sponsorsLive: 'Sponsors Live', viewersNow: 'Live Viewers (Now)', totalScreens: 'Total Screens', onlineScreens: 'Online Screens', activeGroups: 'Active Screen Groups', campaignsToday: 'Campaigns Live Today', tickerEnabled: 'Ticker Enabled', broadcastingNow: 'Broadcasting Now', matchesLive: 'Matches Live', activeBroadcasts: 'Active Broadcasts', announcementsToday: 'Announcements Today', spotlightEvents: 'Spotlight Events', viewers: 'Viewers' },
  builder: { journey: 'Builder Journey', readiness: '{value}% launch-ready', tip: 'Tip: The launch console updates live as you design this event.', hybridHelp: 'Hybrid mode unlocked: design a staged competition flow with unified scoring moments.', golfPresetHelp: 'Curated golf presets ready for launch.', racquetPresetHelp: 'Curated racquet presets ready for launch.', stageGolf: 'Stage 1: Golf Seeding', stageRacquet: 'Stage 2: Racquet Brackets', stageFinals: 'Stage 3: Unified Finals' },
  formats: { matchPlayDescription: 'Head-to-head momentum, hole by hole.' },
  journey: { sport: 'Sport', format: 'Format', setup: 'Setup', rules: 'Rules', sponsors: 'Sponsors', launch: 'Launch' },
  screens: { eyebrow: 'Broadcast Control Room', title: 'Screen Management Studio', subtitle: 'Control every venue display, monetise sponsor inventory, and orchestrate premium in-club storytelling.', lastSeen: 'Last seen {value}', noHeartbeat: 'No heartbeat detected yet' },
  live: { title: 'Live Competitions Studio', subtitle: 'Command live matches, control broadcasts, and orchestrate real-time storytelling.' },
  announcements: { finalGroupCamera: 'Final group entering signature par-3 live camera window.', courtTieBreak: 'Court 1 semi final entering decisive set tie-break.', hospitalityOpen: 'Hospitality terrace now open for finals spectators.' },
  spotlight: { onFire: 'On fire', closingHole: 'Closing hole', bounceBack: 'Bounce-back momentum' },
  timeline: { ethanBirdie15: 'Ethan birdie on 15', crowdSurge: 'Crowd surge at centre court', lucasReplay: 'Lucas chip-in replay', semiFinalTieBreak: 'Semi-final tie-break begins', spotlightHole16: 'Spotlight switch to hole 16' },
  canonical: { sports: { golf: 'Golf', racquet: 'Racquet', multiSport: 'Multi-Sport' }, statuses: { draft: 'Draft', openForEntries: 'Open for entries', entriesClosed: 'Entries closed', inProgress: 'In progress', completed: 'Completed', cancelled: 'Cancelled' }, participants: { individual: 'Individual', team: 'Team', hybrid: 'Hybrid' }, broadcastModes: { leaderboardFocus: 'Leaderboard Focus', matchFocus: 'Match Focus', playerSpotlight: 'Player Spotlight', finalsMode: 'Finals Mode' }, previewModes: { leaderboardFocus: 'Leaderboard Focus', sponsorTicker: 'Sponsor Ticker', matchCentre: 'Match Centre', welcomeScreen: 'Welcome Screen', splitView: 'Split View', sponsorAdvertCard: 'Sponsor Advert Card', playerSpotlight: 'Player Spotlight' }, tickerThemes: { darkNeon: 'Dark Neon', championshipGold: 'Championship Gold', clubClassic: 'Club Classic' }, tickerSpeeds: { slow: 'Slow', standard: 'Standard', fast: 'Fast' }, matchStatuses: { live: 'Live', upcoming: 'Upcoming', completed: 'Completed' }, screenStatuses: { online: 'Online', offline: 'Offline' }, contestTypes: { closestToPin: 'Closest to the Pin', longestDrive: 'Longest Drive' }, fantasyFormats: { salaryCap: 'Salary cap', pickPlayers: 'Pick players' } },
  validation: { nameRequired: 'Competition name is required.', sportRequired: 'Please choose a sport.', typeRequired: 'Please choose a competition type.', startRequired: 'Start date is required.', missingTitle: 'Missing required fields', missingDescription: 'Please complete the highlighted fields before creating your competition.' },
  errors: { create: 'Unable to create competition', review: 'Please review your details and try again.' },
  toasts: { created: 'Competition created', createdDescription: 'Your competition was saved as a draft and is ready for next steps.' },
  screenToasts: { missingClub: 'Missing club context', missingClubDescription: 'Unable to resolve club code.', createError: 'Unable to create screen', refreshError: 'Unable to refresh code', saveError: 'Unable to save screen', updated: 'Screen updated', disconnectError: 'Unable to disconnect', disconnected: 'Device disconnected', reconnectError: 'Unable to generate reconnect code', retry: 'Please try again.' },
  clipboard: { copied: 'Copied', failed: 'Copy failed', manual: 'Please copy the link manually.', screenLinkCopied: 'Screen link copied', linkFailed: 'Unable to copy link' },
  confirmations: { deleteContest: 'Are you sure you want to delete this contest?', removePlayer: 'Are you sure? This will remove the player from the competition.', overwritePairings: 'This will overwrite any existing pairings. Are you sure?', clearTeeTimes: 'This will clear all tee times. Are you sure?' },
  accessibility: { editContest: 'Edit contest', deleteContest: 'Delete contest', editEntry: 'Edit competition entry', deleteEntry: 'Delete competition entry', copyClubCode: 'Copy club code', copyPairingUrl: 'Copy pairing URL', copyScreenUrl: 'Copy screen URL' },
  preview: { assignedCompetition: 'Assigned Competition', scheduledDay: 'Scheduled · Day 1 of 3', liveUpdates: 'Live leaderboard updates and on-course scoring', presentedByPartners: 'Presented by Club Partners', presentedBy: 'Presented by {sponsor}', dayProgress: 'Day {day} of {total}', tickerFallback: 'Privana broadcast ticker · live updates to follow shortly', frontOfHouse: 'Front of House', awaitingAssignment: 'Awaiting competition assignment', standby: 'Standby', graphicsReadyNext: 'Broadcast graphics ready for the next competition start.', broadcast: 'Competition Broadcast', liveCoverage: 'Live competition coverage', graphicsReady: 'Broadcast graphics ready', clubhouse: 'Clubhouse', welcome: 'Welcome to The Privana Club', competitionUpdates: 'Live competition updates', stayTuned: 'Stay tuned for leaderboard changes' },
  copy: {
    "competition_not_found": "Competition not found",
    "back_to_competitions": "Back to Competitions",
    "back_to_all_competitions": "Back to All Competitions",
    "sponsored_by": "Sponsored by:",
    "leaderboard": "Leaderboard",
    "entries": "Entries (",
    "tee_sheet": "Tee Sheet",
    "contests": "Contests",
    "fantasy": "Fantasy",
    "signage": "Signage",
    "live_leaderboard": "Live Leaderboard",
    "no_scores_submitted_yet": "No scores submitted yet.",
    "pos": "Pos",
    "player": "Player",
    "h_cap": "H'cap",
    "total": "Total",
    "live": "LIVE",
    "competition_feed": "Competition Feed",
    "venue": "Venue",
    "scoring_feed_connected_awaiting_first_results": "Scoring feed connected · awaiting first results",
    "fantasy_leaderboard": "Fantasy Leaderboard",
    "rank": "Rank",
    "member": "Member",
    "team_name": "Team Name",
    "points": "Points",
    "fantasy_golf_setup": "Fantasy Golf Setup",
    "configure_the_fantasy_game_for_this_competition": "Configure the fantasy game for this competition.",
    "edit_configuration": "Edit Configuration",
    "format": "Format:",
    "team_size": "Team Size:",
    "captain": "Captain:",
    "no_fantasy_game_configured_yet": "No fantasy game configured yet.",
    "fantasy_game_configuration": "Fantasy Game Configuration",
    "team_size_2": "Team Size",
    "picks_lock_time": "Picks Lock Time",
    "enable_captain_2x_points": "Enable Captain (2x Points)",
    "prize_pool_description": "Prize Pool Description",
    "cancel": "Cancel",
    "save_configuration": "Save Configuration",
    "on_course_contests": "On-Course Contests",
    "manage_special_contests_like_longest_drive": "Manage special contests like Longest Drive.",
    "new_contest": "New Contest",
    "hole": "- Hole #",
    "winner": "Winner:",
    "no_winner_declared_yet": "No winner declared yet.",
    "no_on_course_contests_created_yet": "No on-course contests created yet.",
    "contest_type": "Contest Type",
    "closest_to_the_pin": "Closest to the Pin",
    "longest_drive": "Longest Drive",
    "hole_number": "Hole Number",
    "winner_2": "Winner",
    "select_winner": "Select winner",
    "none": "None",
    "result": "Result",
    "e_g_315_yards_or_3ft_2in": "e.g., 315 yards or 3ft 2in",
    "save_contest": "Save Contest",
    "template": "Template",
    "device_preview": "Device Preview",
    "contest_winners": "Contest Winners",
    "on_course_contest_results": "On-Course Contest Results",
    "sponsored_by_2": "Sponsored by",
    "contest_winners_will_be_announced_soon": "Contest winners will be announced soon.",
    "last_updated": "Last updated:",
    "welcome_to_the": "Welcome to the",
    "waiting_for_scores": "Waiting for scores...",
    "format_studio": "Format Studio",
    "demo_ready": "Demo Ready",
    "hybrid_competition_flow": "Hybrid Competition Flow",
    "popular": "Popular",
    "competition_blueprint": "Competition Blueprint",
    "shape_identity_schedule_and_participation_with_a_broadcast_grade": "Shape identity, schedule, and participation with a broadcast-grade setup.",
    "event_identity": "Event Identity",
    "competition_name": "Competition name",
    "privana_signature_invitational": "Privana Signature Invitational",
    "short_description": "Short description",
    "a_multi_discipline_premium_member_event_with_live_coverage": "A multi-discipline premium member event with live coverage and sponsor integrations.",
    "venue_location": "Venue / location",
    "championship_course_center_court": "Championship Course + Center Court",
    "schedule_participation": "Schedule & Participation",
    "start_date": "Start date",
    "end_date": "End date",
    "max_participants": "Max participants",
    "mode": "Mode",
    "individual": "Individual",
    "team": "Team",
    "hybrid": "Hybrid",
    "rules_scoring_modules": "Rules & Scoring Modules",
    "compose_scoring_logic_blocks_that_feel_ready_for_real": "Compose scoring logic blocks that feel ready for real operations.",
    "core_scoring_controls": "Core Scoring Controls",
    "live_scoring_enabled": "Live scoring enabled",
    "gross_net_leaderboard": "Gross + net leaderboard",
    "round_match_days": "Round / match days",
    "golf_engine": "Golf Engine",
    "handicap_allowances": "Handicap allowances",
    "tie_break_policy": "Tie-break policy",
    "back_nine": "Back Nine",
    "last_6_holes": "Last 6 Holes",
    "sudden_death_playoff": "Sudden Death Playoff",
    "racquet_engine": "Racquet Engine",
    "set_format": "Set format",
    "best_of_3": "Best of 3",
    "best_of_5": "Best of 5",
    "fast_4": "Fast 4",
    "points_structure": "Points structure",
    "standard": "Standard",
    "golden_point_deuce": "Golden Point Deuce",
    "timed_match_format": "Timed Match Format",
    "sponsorship_branding_studio": "Sponsorship & Branding Studio",
    "competition_page": "Competition page",
    "tv_ticker": "TV ticker",
    "screen_adverts": "Screen adverts",
    "screen_overlays": "Screen overlays",
    "position_sponsor_inventory_across_pages_tickers_and_premium_screen": "Position sponsor inventory across pages, tickers, and premium screen surfaces.",
    "title_sponsor": "Title sponsor",
    "logo_media_slot": "Logo / Media Slot",
    "1200x600_png_svg": "1200x600 · PNG/SVG",
    "supporting_sponsor_1": "Supporting sponsor 1",
    "supporting_sponsor_2": "Supporting sponsor 2",
    "commercial_surface_preview": "Commercial Surface Preview",
    "competition_header": "Competition Header",
    "ticker_rotation": "Ticker Rotation",
    "sponsor_loop": "SPONSOR LOOP",
    "launch_console": "Launch Console",
    "review_launch": "Review & Launch",
    "your_premium_event_package_ready_for_broadcast_and_member": "Your premium event package, ready for broadcast and member release.",
    "competition": "Competition",
    "saved_id": "Saved ID:",
    "max": "max ·",
    "launch_readiness": "Launch readiness",
    "all_required_launch_fields_are_complete": "All required launch fields are complete.",
    "save_draft": "Save Draft",
    "preview_screens": "Preview Screens",
    "launch_confidence": "Launch confidence:",
    "complete_identity_and_scheduling_fields_to_finalize_a_fully": "Complete identity and scheduling fields to finalize a fully ready competition package.",
    "screen_inventory": "Screen Inventory",
    "select_a_screen_to_load_its_live_preview_and": "Select a screen to load its live preview and command surfaces.",
    "no_screens_added_yet": "No screens added yet",
    "create_and_pair_your_first_competition_screen_to_unlock": "Create and pair your first competition screen to unlock live inventory, status telemetry, and venue-targeted control.",
    "one_time_pairing_flow_for_tvs_and_signage_laptops": "• One-time pairing flow for TVs and signage laptops",
    "persistent_screen_sessions_with_heartbeat_presence": "• Persistent screen sessions with heartbeat presence",
    "layout_and_sponsor_orchestration_from_one_control_room": "• Layout and sponsor orchestration from one control room",
    "add_screen": "Add Screen",
    "manage_screen": "Manage Screen",
    "layout": "Layout:",
    "source": "Source:",
    "ticker": "Ticker:",
    "ad_loop": "Ad Loop:",
    "live_preview_canvas": "Live Preview Canvas ·",
    "ticker_configuration": "Ticker Configuration",
    "broadcast_footer_controls_for_sponsors_match_updates_and_urgent": "Broadcast footer controls for sponsors, match updates, and urgent announcements.",
    "ticker_enabled": "Ticker enabled",
    "theme": "Theme",
    "speed": "Speed",
    "logo_mode": "Logo mode",
    "sponsor_logos_only": "Sponsor logos only",
    "logos_text": "Logos + text",
    "include_competition_updates": "Include competition updates",
    "urgent_announcements": "Urgent announcements",
    "ticker_sim_rolex_finals_countdown_court_1_live_in": "[Ticker Sim] Rolex Finals Countdown · Court 1 live in 04:00 · Hospitality partner showcase begins at 18:00.",
    "advert_scheduler_playlist": "Advert Scheduler & Playlist",
    "design_sponsor_playback_loops_and_intermission_placements_with_commercial": "Design sponsor playback loops and intermission placements with commercial clarity.",
    "assigned": "Assigned:",
    "playlist_timeline": "Playlist timeline",
    "screen_groups": "Screen Groups",
    "deploy_synchronized_layouts_and_sponsor_packages_to_grouped_venue": "Deploy synchronized layouts and sponsor packages to grouped venue zones.",
    "screens": "screens ·",
    "active_campaigns": "active campaigns",
    "assign_layout": "Assign Layout",
    "push_campaign": "Push Campaign",
    "content_rotation_timeline": "Content Rotation Timeline",
    "static_demo_loop_builder_showing_proportioned_broadcast_sequencing": "Static demo loop builder showing proportioned broadcast sequencing.",
    "s": "s",
    "loop_length": "Loop length:",
    "s_auto_repeats_continuously_on_assigned_screens": "s · Auto-repeats continuously on assigned screens.",
    "sponsor_campaign_manager": "Sponsor Campaign Manager",
    "sales_friendly_campaign_snapshots_for_sponsors_targets_frequencies_and": "Sales-friendly campaign snapshots for sponsors, targets, frequencies, and priorities.",
    "type": "Type:",
    "competition_2": "Competition:",
    "dates": "Dates:",
    "targets": "Targets:",
    "playback": "Playback:",
    "priority": "Priority:",
    "live_override_console": "Live Override Console",
    "instant_operational_controls_for_high_pressure_moments": "Instant operational controls for high-pressure moments.",
    "add_competition_screen": "Add Competition Screen",
    "create_a_screen_and_generate_a_short_lived_one": "Create a screen and generate a short-lived one-time pairing code.",
    "pair_your_screen_first": "Pair your screen first",
    "follow_these_quick_steps_on_the_target_display_before": "Follow these quick steps on the target display before creating this screen.",
    "step_1_open_this_on_your_screen": "Step 1 · Open this on your screen",
    "step_2_enter_your_club_code": "Step 2 · Enter your club code",
    "screen_name_display_name": "Screen Name / Display Name",
    "this_helps_your_team_identify_the_display_location_quickly": "This helps your team identify the display location quickly.",
    "active_one_time_code": "Active one-time code",
    "code_refreshes_in": "Code refreshes in",
    "current_code_expires_at": "Current code expires at",
    "club_code": "Club code",
    "base_pairing_url": "Base pairing URL",
    "unique_screen_url": "Unique screen URL",
    "open": "Open",
    "on_the_target_screen_enter_club_code": "on the target screen, enter club code",
    "then_enter_the_one_time_code": ", then enter the one-time code.",
    "done": "Done",
    "edit_broadcast_behavior_and_device_state": "Edit broadcast behavior and device state.",
    "display": "Display",
    "display_name": "Display name",
    "location": "Location",
    "screen_link": "Screen link",
    "copy_the_direct_display_url_for_this_screen": "Copy the direct display URL for this screen.",
    "copy_screen_link": "Copy screen link",
    "broadcast": "Broadcast",
    "layout_preset": "Layout preset",
    "select_layout_preset": "Select layout preset",
    "unknown_preset_saved": "Unknown preset (saved):",
    "assigned_competition_id": "Assigned competition ID",
    "device": "Device",
    "orientation": "Orientation",
    "resolution": "Resolution",
    "group_id": "Group ID",
    "messaging": "Messaging",
    "standby_message": "Standby message",
    "toggles": "Toggles",
    "public_facing": "Public facing",
    "reconnect_screen": "Reconnect Screen",
    "use_this_one_time_code_to_pair_the_existing": "Use this one-time code to pair the existing screen again.",
    "one_time_code": "One-time code",
    "loading_managed_screens": "Loading managed screens…",
    "create_and_pair_your_first_screen_to_unlock_live": "Create and pair your first screen to unlock live ticker, advert scheduling, and layout controls.",
    "live_match_selector": "Live Match Selector",
    "choose_the_active_match_feed_for_command_operations": "Choose the active match feed for command operations.",
    "status": "· Status:",
    "broadcast_mode": "Broadcast mode",
    "select_mode": "Select mode",
    "player_spotlight": "Player Spotlight",
    "current_leader": "Current leader ·",
    "featured_live": "· Featured live",
    "live_ticker": "Live ticker:",
    "leaderboard_control_panel": "Leaderboard Control Panel",
    "match_control_panel": "Match Control Panel",
    "announcements_panel": "Announcements Panel",
    "type_announcement": "Type announcement...",
    "push_announcement": "Push Announcement",
    "spotlight_queue_panel": "Spotlight Queue Panel",
    "push_to_broadcast": "Push to broadcast",
    "remove": "Remove",
    "match_timeline_panel": "Match Timeline Panel",
    "live_sequence_of_score_updates_events_and_highlight_triggers": "Live sequence of score updates, events, and highlight triggers.",
    "production_critical_actions_for_high_pressure_broadcast_control": "Production-critical actions for high-pressure broadcast control.",
    "manage_pairings_and_tee_times": "Manage pairings and tee times.",
    "auto_generate": "Auto-Generate",
    "clear_sheet": "Clear Sheet",
    "tee_time": "Tee Time",
    "players": "Players",
    "tee_sheet_has_not_been_generated": "Tee sheet has not been generated.",
    "search_members": "Search members...",
    "no_members_found": "No members found.",
    "selected": "Selected:",
    "competition_entries": "Competition Entries",
    "manage_participants_for_this_event": "Manage participants for this event.",
    "add_participants": "Add Participants",
    "player_name": "Player Name",
    "h_cap_index": "H'cap Index",
    "playing_h_cap": "Playing H'cap",
    "payment": "Payment",
    "actions": "Actions",
    "no_entries_yet": "No entries yet.",
    "edit_entry": "Edit Entry",
    "handicap_index": "Handicap Index",
    "save_changes": "Save Changes",
    "add_new_participants": "Add New Participants",
    "members": "Members",
    "h_cap_index_2": "H'Cap Index",
    "next": "Next",
    "back": "Back",
    "save_participants": "Save Participants",
    "starting_times": "Starting Times",
    "tee_times_have_not_been_assigned_yet": "Tee times have not been assigned yet.",
    "golf": "Golf",
    "precision_scoring_and_marquee_course_storytelling": "Precision scoring and marquee course storytelling.",
    "ideal_for_member_majors_invitationals_and_broadcast_ready_rounds": "Ideal for member majors, invitationals, and broadcast-ready rounds.",
    "racquet": "Racquet",
    "tennis_padel_and_racquet_leagues_in_one_flow": "Tennis, padel, and racquet leagues in one flow.",
    "built_for_ladders_tournaments_and_club_vs_club_showcases": "Built for ladders, tournaments, and club-vs-club showcases.",
    "multi_sport": "Multi-Sport",
    "a_premium_hybrid_event_engine_for_signature_championships": "A premium hybrid event engine for signature championships.",
    "combine_golf_racquet_stages_with_unified_club_wide_storytelling": "Combine golf + racquet stages with unified club-wide storytelling.",
    "stableford": "Stableford",
    "points_by_hole_with_handicap_friendly_pacing": "Points by hole with handicap-friendly pacing.",
    "strategic_fast": "Strategic · Fast",
    "stroke_play": "Stroke Play",
    "classic_aggregate_scoring_across_rounds": "Classic aggregate scoring across rounds.",
    "traditional_premium": "Traditional · Premium",
    "match_play": "Match Play",
    "dramatic_broadcast": "Dramatic · Broadcast",
    "best_ball_scramble": "Best Ball Scramble",
    "team_creativity_with_best_shot_selection": "Team creativity with best-shot selection.",
    "social_team_energy": "Social · Team Energy",
    "wolf": "Wolf",
    "rotating_strategy_and_decision_pressure_each_hole": "Rotating strategy and decision pressure each hole.",
    "dynamic_interactive": "Dynamic · Interactive",
    "round_robin": "Round Robin",
    "balanced_fixture_grid_with_standings_momentum": "Balanced fixture grid with standings momentum.",
    "fair_consistent": "Fair · Consistent",
    "knockout": "Knockout",
    "single_elimination_bracket_with_spotlight_matches": "Single-elimination bracket with spotlight matches.",
    "fast_high_stakes": "Fast · High Stakes",
    "double_elimination": "Double Elimination",
    "second_life_pathway_with_stronger_parity": "Second life pathway with stronger parity.",
    "competitive_extended": "Competitive · Extended",
    "ladder_league": "Ladder League",
    "challenge_ladder_for_season_long_movement": "Challenge ladder for season-long movement.",
    "persistent_engaging": "Persistent · Engaging",
    "team_league": "Team League",
    "squad_fixtures_with_tactical_lineups": "Squad fixtures with tactical lineups.",
    "club_pride_tactical": "Club Pride · Tactical",
    "sport": "Sport",
    "format_2": "Format",
    "setup": "Setup",
    "rules": "Rules",
    "sponsors": "Sponsors",
    "launch": "Launch",
    "layout_1": "Layout 1",
    "main_feed_with_right_side_leaderboard_rail_and_live": "Main feed with right-side leaderboard rail and live lower-third ticker",
    "leaderboard_focus": "Leaderboard Focus",
    "sponsor_ticker": "Sponsor Ticker",
    "match_centre": "Match Centre",
    "welcome_screen": "Welcome Screen",
    "split_view": "Split View",
    "sponsor_advert_card": "Sponsor Advert Card",
    "video_advert": "Video Advert",
    "every_3_mins": "Every 3 mins",
    "live_2": "Live",
    "bar_lounge_lobby": "Bar & Lounge, Lobby",
    "image_advert": "Image Advert",
    "every_loop": "Every loop",
    "queued": "Queued",
    "golf_areas": "Golf Areas",
    "full_screen_takeover": "Full-Screen Takeover",
    "top_of_hour": "Top of hour",
    "all_public_screens": "All Public Screens",
    "intermission_card": "Intermission Card",
    "between_matches": "Between matches",
    "draft": "Draft",
    "racquet_areas": "Racquet Areas",
    "sponsor_slate": "Sponsor Slate",
    "every_5_mins": "Every 5 mins",
    "reception_lobby": "Reception & Lobby",
    "bar_lounge": "Bar & Lounge",
    "leaderboard_focus_2": "Leaderboard Focus",
    "reception_lobby_2": "Reception & Lobby",
    "welcome_screen_2": "Welcome Screen",
    "golf_areas_2": "Golf Areas",
    "clubhouse_mixed_feed": "Clubhouse Mixed Feed",
    "racquet_areas_2": "Racquet Areas",
    "match_centre_2": "Match Centre",
    "all_public_screens_2": "All Public Screens",
    "finals_day_mode": "Finals Day Mode",
    "fixtures": "Fixtures",
    "sponsor_reel": "Sponsor Reel",
    "match_spotlight": "Match Spotlight",
    "club_promo": "Club Promo",
    "premium_brand_loop": "Premium Brand Loop",
    "all_public_screens_3": "All Public Screens",
    "every_4_mins": "Every 4 mins",
    "active": "Active",
    "equipment_launch": "Equipment Launch",
    "golf_areas_3": "Golf Areas",
    "every_6_mins": "Every 6 mins",
    "lifestyle_spotlight": "Lifestyle Spotlight",
    "bar_lounge_2": "Bar & Lounge",
    "hourly_takeover": "Hourly takeover",
    "scheduled": "Scheduled",
    "wellness_card": "Wellness Card",
    "racquet_areas_3": "Racquet Areas",
    "every_loop_2": "Every loop",
    "leaderboard_focus_3": "Leaderboard Focus",
    "live_leaderboard_dominance": "Live leaderboard dominance",
    "scores_stay_central_with_a_compact_sponsor_ribbon_and": "Scores stay central with a compact sponsor ribbon and rotation-ready footer.",
    "sponsor_ticker_2": "Sponsor Ticker",
    "sponsor_led_ticker_mode": "Sponsor-led ticker mode",
    "commercial_headlines_lead_the_footer_while_updates_pulse_between": "Commercial headlines lead the footer while updates pulse between placements.",
    "match_centre_3": "Match Centre",
    "match_centre_telemetry": "Match centre telemetry",
    "fixture_cards_and_live_status_widgets_prioritize_active_court": "Fixture cards and live status widgets prioritize active court and course moments.",
    "welcome_screen_3": "Welcome Screen",
    "arrival_and_welcome_ambience": "Arrival and welcome ambience",
    "hero_greeting_weather_highlights_and_next_tee_times_greet": "Hero greeting, weather highlights, and next tee times greet members on entry.",
    "split_view_2": "Split View",
    "dual_feed_split_view": "Dual feed split view",
    "competition_feed_runs_beside_sponsor_inventory_for_balanced_engagement": "Competition feed runs beside sponsor inventory for balanced engagement.",
    "sponsor_advert_card_2": "Sponsor Advert Card",
    "full_sponsor_card_feature": "Full sponsor card feature",
    "high_impact_sponsor_creative_sits_front_and_center_with": "High-impact sponsor creative sits front and center with premium framing.",
    "player_spotlight_mode": "Player spotlight mode",
    "athlete_profile_treatment_with_live_ranking_and_next_up": "Athlete profile treatment with live ranking and next-up callouts.",
    "final_group_hole_16": "Final Group · Hole 16",
    "court_1_semi_final": "Court 1 Semi Final",
    "final_group_hole_12": "Final Group · Hole 12",
    "court_2_quarter_final": "Court 2 Quarter Final",
    "final_group_hole_8": "Final Group · Hole 8",
    "final_group_entering_signature_par_3_live_camera_window": "Final group entering signature par-3 live camera window.",
    "court_1_semi_final_entering_decisive_set_tie_break": "Court 1 semi final entering decisive set tie-break.",
    "hospitality_terrace_now_open_for_finals_spectators": "Hospitality terrace now open for finals spectators.",
    "on_fire": "On fire",
    "closing_hole": "Closing hole",
    "bounce_back_momentum": "Bounce-back momentum",
    "ethan_birdie_on_15": "Ethan birdie on 15",
    "crowd_surge_at_center_court": "Crowd surge at center court",
    "lucas_chip_in_replay": "Lucas chip-in replay",
    "semi_final_tie_break_begins": "Semi final tie-break begins",
    "spotlight_switch_to_hole_16": "Spotlight switch to hole 16",
    "leaderboard_focus_4": "Leaderboard Focus",
    "match_focus": "Match Focus",
    "finals_mode": "Finals Mode"
  }
};
